import { render, staticRenderFns } from "./Handle.vue?vue&type=template&id=4b549582&scoped=true"
import script from "./Handle.vue?vue&type=script&lang=js"
export * from "./Handle.vue?vue&type=script&lang=js"
import style0 from "./Handle.vue?vue&type=style&index=0&id=4b549582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b549582",
  null
  
)

export default component.exports